import React, { useState, useRef, useEffect, Fragment } from "react";
import { CaretDownSolidIcon, CaretUpSolidIcon } from "../../../../assets/icons";
import Pagination from "../../../shared/common/pagination";
import SelectPageSize from "../../../shared/common/pageSizeDropdown";
import { getStateAll } from "../../../../api/subject.service";
import { getMiniCRMSchools } from "../../../../api/miniCrm.service";
import { IReactSelect } from "../../../../model/interface/keyValuePair";
import Loader from "../../../shared/loader/loader";
import SchoolPopup from "./schoolPopUP";

interface IUnmappedSchoolProps {
  userId: number;
  unmappedSchool: any;
  unmappedNWEASchools: any;
  onMappingChanged: () => void;
}

const UnmappedSchool: React.FC<IUnmappedSchoolProps> = ({
  userId,
  unmappedSchool,
  unmappedNWEASchools,
  onMappingChanged,
}: {
  userId: number;
  unmappedSchool: any;
  unmappedNWEASchools: any;
  onMappingChanged;
}) => {
  const defaultSelect = { label: "", value: 0 };
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [sortCol, setSortCol] = useState<string>("");
  const [sortByDesc, setSortByDesc] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [states, setStates] = useState<Array<any>>([]);
  const [selectedState, setSelectedStates] = useState<IReactSelect>();
  const [districts, setDistricts] = useState<Array<any>>([]);
  const [selectedDistrict, setSelectedDistrict] =
    useState<IReactSelect>(defaultSelect);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [schools, setSchools] = useState<Array<any>>([]);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRegion, setSelectedRegion] = useState<any>({
    label: "",
    value: "",
  });
  const [school, setSchool] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showSchoolPopup, setShowSchoolPopup] = useState<boolean>(false);

  useEffect(() => {
    if (isLoaded) {
      getSchools();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      getSchools();
      getStates();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  useEffect(() => {
    if (isLoaded) {
      getSchools();
    }
  }, [sortByDesc]);

  const getStates = async () => {
    const resp: any = await getStateAll(9999, 1);
    if (resp && resp.data) {
      setStates(
        resp?.data?.data?.map((ds) => ({
          label: ds.name,
          value: ds.stateId,
        }))
      );
    }
  };

  const closeSchoolModal = () => {
    setShowSchoolPopup(false);
  };
  const mapSchool = () => {
    onMappingChanged();
    clearSchools();
    setShowSchoolPopup(false);
  };

  const getSchools = async (isReset?) => {
    setLoading(true);
    setSchools([unmappedSchool]);
    setTotalPages(1);
    setLoading(false);
  };

  const clearSchools = () => {
    setLoading(true);
    setSchools([]);
    setTotalPages(0);
    setLoading(false);
  };

  const handleSortBy = (column: string) => {
    setSortByDesc(!sortByDesc);
    setSortCol(column);
  };

  return (
    <Fragment>
      {loading && <Loader />}

      {showSchoolPopup &&
        unmappedNWEASchools &&
        unmappedNWEASchools.length > 0 && (
          <SchoolPopup
            closeSchoolModal={closeSchoolModal}
            userId={userId}
            mapSchool={mapSchool}
            unmappedNWEASchools={unmappedNWEASchools}
          />
        )}

      <h1 className="mt-4">List of unmapped schools</h1>
      <form id="users_form">
        <div id="dataContainer" className="border-t ">
          <div className="flex flex-col mt-1">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-primary-color">
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                        >
                          <span className="flex">
                            School Name
                            <span className="cursor-pointer">
                              {sortByDesc && sortCol === "schoolName" ? (
                                <CaretUpSolidIcon
                                  onClick={() => handleSortBy("schoolName")}
                                  className="w-5 h-5"
                                ></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon
                                  onClick={() => handleSortBy("schoolName")}
                                  className="w-5 h-5"
                                ></CaretDownSolidIcon>
                              )}
                            </span>
                          </span>
                        </th>

                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                        >
                          <span className="flex">
                            District
                            <span className="cursor-pointer">
                              {sortByDesc && sortCol === "district" ? (
                                <CaretUpSolidIcon
                                  onClick={() => handleSortBy("district")}
                                  className="w-5 h-5"
                                ></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon
                                  onClick={() => handleSortBy("district")}
                                  className="w-5 h-5"
                                ></CaretDownSolidIcon>
                              )}
                            </span>
                          </span>
                        </th>

                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                        >
                          <span className="flex">
                            City
                            <span className="cursor-pointer">
                              {sortByDesc && sortCol === "city" ? (
                                <CaretUpSolidIcon
                                  onClick={() => handleSortBy("city")}
                                  className="w-5 h-5"
                                ></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon
                                  onClick={() => handleSortBy("city")}
                                  className="w-5 h-5"
                                ></CaretDownSolidIcon>
                              )}
                            </span>
                          </span>
                        </th>

                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                        >
                          <span className="flex">
                            State
                            <span className="cursor-pointer">
                              {sortByDesc && sortCol === "state" ? (
                                <CaretUpSolidIcon
                                  onClick={() => handleSortBy("state")}
                                  className="w-5 h-5"
                                ></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon
                                  onClick={() => handleSortBy("state")}
                                  className="w-5 h-5"
                                ></CaretDownSolidIcon>
                              )}
                            </span>
                          </span>
                        </th>

                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                        >
                          <span className="flex">
                            Zip
                            <span className="cursor-pointer">
                              {sortByDesc && sortCol === "zip" ? (
                                <CaretUpSolidIcon
                                  onClick={() => handleSortBy("zip")}
                                  className="w-5 h-5"
                                ></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon
                                  onClick={() => handleSortBy("zip")}
                                  className="w-5 h-5"
                                ></CaretDownSolidIcon>
                              )}
                            </span>
                          </span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                        >
                          NWEA Id
                        </th>
                        <th className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {schools?.map((school, i) => (
                        <tr
                          key={i}
                          className={`align-top ${
                            i % 2 === 0 ? "bg-white " : "bg-gray-100"
                          }`}
                        >
                          <td className=" px-3 py-2  text-sm text-left font-normal relative">
                            <button className="text-indigo-500" type="button">
                              {school.name}
                            </button>
                          </td>
                          <td className=" px-3 py-2  text-sm text-left font-normal relative">
                            {school.districtName}
                          </td>
                          <td className=" px-3 py-2  text-sm text-left font-normal relative">
                            {school.city}
                          </td>
                          <td className=" px-3 py-2  text-sm text-left font-normal relative">
                            {school.stateName}
                          </td>
                          <td className=" px-3 py-2  text-sm text-left font-normal relative">
                            {school.zipCode}
                          </td>
                          <td className=" px-3 py-2  text-sm text-center font-normal relative">
                            Multiple
                          </td>
                          <td className=" px-3 py-2  text-sm text-center font-normal relative">
                            <button
                              className="text-indigo-500"
                              type="button"
                              onClick={() => {
                                setShowSchoolPopup(true);
                              }}
                            >
                              Map
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {schools.length === 0 && (
                    <p className="p-2">No Records Found</p>
                  )}
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center">
              <Pagination
                pages={totalPages}
                setPageNumber={setPageNumber}
                ref={paginationRef}
              />
              <span>
                <span className="text-sm pr-4 ml-auto text-left-700">
                  Showing {pageNumber} to{" "}
                  {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                  {totalRecords} results{" "}
                </span>

                <SelectPageSize
                  setPageSize={setPageSize}
                  type={"second"}
                  ref={pageSizeRef}
                />
              </span>
            </div>
          </div>
        </div>
      </form>
    </Fragment>
  );
};
export default UnmappedSchool;
